import UserAvatar from "@/components/lazo-ai-chat-components/Avatar";
import { Colors } from "@/enums/Colors";
import { LazoUser } from "@/models/LazoUser";
import { Popper, Skeleton, SxProps, Typography } from "@mui/material";
import { Box, styled } from "@mui/system";
import { Dispatch, SetStateAction } from "react";

type UserCardPopperProps = {
  anchorEl: HTMLDivElement;
  lazoUser: LazoUser;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  closeCardTimeoutHandle: NodeJS.Timeout;
  setCloseCardTimeoutHandle: Dispatch<SetStateAction<NodeJS.Timeout | null>>;
};

function UserCardPopper(props: UserCardPopperProps) {
  function handleUserCardMouseEnter() {
    props.setOpen(true);
    clearTimeout(props.closeCardTimeoutHandle);
    props.setCloseCardTimeoutHandle(null);
  }

  return (
    <StyledPopper
      placement={"top-start"}
      anchorEl={props.anchorEl}
      open={props.open}
      onMouseLeave={() => props.setOpen(false)}
      onMouseEnter={() => handleUserCardMouseEnter()}
      modifiers={[
        {
          name: "offset",
          options: {
            offset: [0, 20],
          },
        },
      ]}
    >
      {props.lazoUser ? (
        <UserAvatarContent>
          <UserAvatar sx={UserAvatarSx} user={props.lazoUser.user} />
          <UserAvatarTextContainer>
            <UserNameTypography>{props.lazoUser.user.firstName + " " + props.lazoUser.user.lastName}</UserNameTypography>
            <UserRoleTypography>{props.lazoUser.email}</UserRoleTypography>
          </UserAvatarTextContainer>
        </UserAvatarContent>
      ) : (
        <Skeleton variant={"rectangular"} sx={{ width: "100px", height: "80px" }} />
      )}
    </StyledPopper>
  );
}
const StyledPopper = styled(Popper)(() => ({
  borderRadius: "0.5rem",
  border: `1px solid ${Colors.LIGHT_GRAY_DEDEE1}`,
  padding: "1rem",
  backgroundColor: Colors.WHITE,
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  gap: "0.75rem",
}));

const UserAvatarContent = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
}));

const UserAvatarSx: SxProps = {
  border: `1px solid ${Colors.LIGHT_GRAY_DEDEE1}`,
  backgroundColor: "#fff",
  backgroundImage: "none",
  borderRadius: "0.5rem",
  fontSize: "1.125rem",
  color: Colors.BLACK,
  fontWeight: 500,
  width: "56px",
  height: "56px",
};

const UserAvatarTextContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "start",
  gap: "0.125rem",
}));

const UserNameTypography = styled(Typography)(() => ({
  fontSize: "0.75rem",
  fontWeight: 600,
  color: Colors.BLACK,
}));

const UserRoleTypography = styled(Typography)(() => ({
  fontSize: "0.75rem",
  fontWeight: 400,
  color: Colors.LIGHT_GRAY_8A8E93,
}));

export default UserCardPopper;
